<template>
  <div>
    <div class="axis-legend-explain">
      <h4 style="margin-top: 1em; font-size: 14px;">{{ $t('surveyResult.axis-legend.title') }}</h4>
      <p>{{ $t('surveyResult.axis-legend.p1') }}</p>
      <img src="@/assets/images/explication-score-min.jpg" />
      <p>{{ $t('surveyResult.axis-legend.p2') }}</p>
      <p>{{ $t('surveyResult.axis-legend.p3') }}</p>
      <p>{{ $t('surveyResult.axis-legend.p4') }}</p>
      <p>{{ $t('surveyResult.axis-legend.p5') }}</p>
      <p style="margin-left: 1cm;">{{ $t('surveyResult.axis-legend.p6') }}</p>
      <p style="margin-left: 1cm;">{{ $t('surveyResult.axis-legend.p7') }}</p>
      <p style="margin-left: 1cm;">{{ $t('surveyResult.axis-legend.p8') }}</p>
      <p>{{ $t('surveyResult.axis-legend.p9') }}</p>
      <p style="margin-left: 1cm;">{{ $t('surveyResult.axis-legend.p10') }}</p>
    </div>
    <table class="response-table">
      <thead>
        <tr>
          <th class="th-score">
            <img src="@/assets/svg/axe_1_infrastructure.svg" />
          </th>
          <th class="th-score">
            <img src="@/assets/svg/axe_2_organisation.svg" />
          </th>
          <th class="th-score">
            <img src="@/assets/svg/axe_3_processus.svg" />
          </th>
          <th class="th-score">
            <img src="@/assets/svg/axe_4_strategie.svg" />
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(response, responseIndex) in responses">
          <template v-if="response.answer && (typeof response.answer === 'string' || response.answer.length > 0)">
            <tr :key="`theme-${response.question.num}`" class="tr-theme" v-if="response.question.isStartTheme">
              <td colspan="5"><span>{{ response.question.themeName }}</span></td>
            </tr>
            <template v-if="!response.hidden">
              <tr :key="`question-${response.question.num}`" class="tr-question">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <p class="question">{{ responseIndex + 1 - getSkippedQuestionsBefore(responseIndex) }}. {{ response.question.title }}</p>
                </td>
              </tr>
              <template v-if="typeof response.answer === 'string'">
                  <tr :key="`responses-${response.question.num}-answer`">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="answered">
                      {{ response.answer }}
                    </td>
                  </tr>
              </template>
              <template v-else>
                <template v-for="(answer, answerIndex) in response.answer">
                  <tr :key="`responses-${response.question.num}-${answerIndex}`">
                    <td class="td-score">
                      <div v-if="isAxisVisible(answer, 'Infra')" class="axis-scoring" :class="getAnswserAxisClass(answer, 'Infra')">
                        <img src="@/assets/svg/axe_1_infrastructure.svg" />
                      </div>
                    </td>
                    <td class="td-score">
                      <div v-if="isAxisVisible(answer, 'Human')" class="axis-scoring" :class="getAnswserAxisClass(answer, 'Human')">
                        <img src="@/assets/svg/axe_2_organisation.svg" />
                      </div>
                    </td>
                    <td class="td-score">
                      <div v-if="isAxisVisible(answer, 'Process')" class="axis-scoring" :class="getAnswserAxisClass(answer, 'Process')">
                        <img src="@/assets/svg/axe_3_processus.svg" />
                      </div>
                    </td>
                    <td class="td-score">
                      <div v-if="isAxisVisible(answer, 'Strategy')" class="axis-scoring" :class="getAnswserAxisClass(answer, 'Strategy')">
                        <img src="@/assets/svg/axe_4_strategie.svg" />
                      </div>
                    </td>
                    <td :class="{ answered: answer.answered }">
                      <template v-if="response.answer.length > 1">{{ answerIndex + 1 }}. </template>{{ answer.label }}
                      <template v-if="answer.description">
                        <br /><small class="answer-description"><span class="fa fa-info-circle"></span> {{ answer.description }}</small>
                      </template>
                    </td>
                  </tr>
                </template>
              </template>
            </template>
          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Response',
  props: [
    'responses',
  ],
  methods: {
    isAxisVisible(answer, axis) {
      if (answer.axis) {
        const axisMeta = answer.axis[axis];
        return axisMeta !== '' && answer.answered;
      }
      return false;
    },
    getAnswserAxisClass(answer, axis) {
      const axisMeta = answer.axis[axis];
      if ((axisMeta === '1' || axisMeta === '2') && answer.answered) {
        return 'success';
      }
      if (axisMeta === '0' && answer.answered) {
        return 'fail';
      }
      return '';
    },
    getSkippedQuestionsBefore(questionIndex) {
      return this.responses.slice(0, questionIndex).filter((q) => q.hidden || !q.answer || (typeof q.answer !== 'string' && q.answer.length < 1)).length;
    },
  },
};
</script>

<style scoped>
.response-table .th-score {
  text-align: center;
  font-size: 12px;
  width: 80px;
}
.response-table .th-score img {
  width: 60%;
}
.response-table .td-score {
  font-weight: bold;
  text-align: center;
}
.response-table .tr-theme td {
  border: none;
  padding: 0;
}
.response-table .tr-theme span {
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  display: block;
  width: 100%;
  border: 1px solid #0d93d2;
  color: #0d93d2;
}
.response-table .tr-question {
  border-top: 1px dashed #eee;
}
.response-table .question {
  font-weight: bold;
  font-size: 14px;
  background-color: #ccc !important;
  padding: 0.5em;
  width: 100%;
}
.response-table .answered {
  font-weight: bold;
  color: #0d93d2;
}
.response-table td {
  border-left: 1px solid #ccc;
  padding: 0.5em;
  vertical-align: middle;
}
.response-table th {
  border-left: 1px solid #ccc;
}
.response-table .axis-scoring {
  padding: 0.5em 0;
}
.response-table .axis-scoring img {
  width: 60%;
}
.response-table .axis-scoring.fail img {
  filter: invert(30%) sepia(54%) saturate(2042%) hue-rotate(342deg) brightness(101%) contrast(91%);
  width: 60%;
}
.response-table .axis-scoring.success img {
  filter: invert(49%) sepia(41%) saturate(736%) hue-rotate(44deg) brightness(102%) contrast(90%);
}
.axis-legend {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1cm;
  margin-bottom: 1cm;
}
.axis-legend > div {
  display: flex;
  align-items: center;
}
.axis-legend img {
  height: 1cm;
  margin: 0 5px 0 10px;
}
.axis-legend-explain {
  margin-bottom: 2em;
}
.answer-description {
  font-style: italic;
}
@media print {
  .response-table .th-score {
    font-size: 8px;
    padding: 0 5px;
    width: 40px;
  }
}
</style>
